import { BusinessType } from './types'

export interface BusinessForBusiness {
  id: number
  businessNumber: string
  businessTypes?: BusinessType[]
  name: string
  phoneNumber: string
  address: string
  description: string
  proposalUsableCount: number
  contactingUsableCount: number
  agreedToJobSupportProjectAt?: string
  businessClients?: {
    id: number
    businessId: number
    clientId: number
    jobPosition: string
  }[]
  businessCeoInfo?: {
    name: string
  }
}

export interface BusinessSingleView {
  id: number
  businessNumber: string
  businessTypes?: BusinessType[]
  name: string
  phoneNumber: string
  address: string
  description: string
  proposalUsableCount: number
  contactingUsableCount: number
}

export enum BusinessRegistrationStatus {
  Rejected = 'rejected',
  Waiting = 'waiting',
  Approved = 'approved',
}

export interface BusinessRegistration {
  id: number
  businessId: number
  fileUrl: string
  createdAt: string
  updatedAt: string
  status: BusinessRegistrationStatus
}

export type BusinessFreeTrialUser = {
  id: bigint
  name: string
  distance: number
  birthYear: number
  image?: string
  gender: string
}
